export const JOBS_BASE_PATH = '/cg_jobs';

export type JobPortalRoute =
  | { page: 'jobs' }
  | { page: 'job'; jobId: string };

export const getJobPortalRoute = (pathname = window.location.pathname): JobPortalRoute => {
  const match = pathname.match(/^\/cg_jobs\/job\/([^/]+)\/?$/i);
  if (!match) return { page: 'jobs' };

  return { page: 'job', jobId: decodeURIComponent(match[1]) };
};

export const migrateLegacyHashRoute = (): JobPortalRoute => {
  if (window.location.hash) {
    const legacyJobMatch = window.location.hash.match(/^#\/job\/([^/?#]+)/i);
    const cleanPath = legacyJobMatch
      ? `${JOBS_BASE_PATH}/job/${encodeURIComponent(decodeURIComponent(legacyJobMatch[1]))}`
      : `${window.location.pathname}${window.location.search}`;

    window.history.replaceState(null, '', cleanPath);
  }

  return getJobPortalRoute();
};

export const navigateToPath = (path: string, replace = false) => {
  const method = replace ? 'replaceState' : 'pushState';
  window.history[method](null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const navigateToJobs = (replace = false) => navigateToPath(`${JOBS_BASE_PATH}/`, replace);

export const navigateToJob = (jobId: string | number) => {
  navigateToPath(`${JOBS_BASE_PATH}/job/${encodeURIComponent(String(jobId))}`);
};
